export default {
  TOGGLE_SIDE_MENU: "TOGGLE_SIDE_MENU",
};
